import { Checkbox, Typography } from '@mui/material';
import { ThemePalette } from 'mui.theme';
import styled from 'styled-components';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

const darkPalette = clientThemePalette[CLIENT_THEME].dark;

export const AssetCard = styled.div<{ enabledarktheme: boolean }>`
  background-color: ${(props) =>
    props.enabledarktheme ? darkPalette.pageBackground : '#fff'};
  border-radius: 5px;
  // padding: 10px;
  box-shadow: ${(props) =>
    props.enabledarktheme ? 'none' : '0px 2px 4px rgba(0, 0, 0, 0.1)'};
  border: 1px solid
    ${(props) => (props.enabledarktheme ? darkPalette.menuOptions : '#E5E5E5')};
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: ${(props) =>
      props.enabledarktheme ? darkPalette.menuOptions : '#b5b5b5'};
    box-shadow: ${(props) =>
      props.enabledarktheme ? 'none' : '0px 2px 4px rgba(0, 0, 0, 0.1)'};
    border: 1px solid
      ${(props) =>
        props.enabledarktheme ? darkPalette.menuOptions : '#E5E5E5'};
  }
`;

/*

<Checkbox
  sx={{
    color: enableDarkTheme
      ? darkPalette.primary
      : ThemePalette.typography.primary,
    '&.Mui-checked': {
      color: enableDarkTheme
        ? darkPalette.primary
        : ThemePalette.typography.primary,
    },
    '&.Mui-disabled': {
      color: ThemePalette.typography.secondary,
    },
    position: 'absolute',

    top: '5px',
    left: '0px',
    transform: 'scale(0.7)',
  }}
  checked={isChecked}
  onChange={(e) => {
    if (!e.target.value) return;
    handleCheckBoxSelected(assetId);
  }}
/>

*/

export const StyledCheckBox = styled(Checkbox)<{ enabledarktheme: boolean }>`
  color: ${({ enabledarktheme }) =>
    enabledarktheme ? darkPalette.primary : ThemePalette.typography.primary};
  &.Mui-checked {
    color: ${({ enabledarktheme }) =>
      enabledarktheme ? darkPalette.primary : ThemePalette.typography.primary};
  }
  &.Mui-disabled {
    color: ThemePalette.typography.secondary;
  }
  position: absolute;
  top: 0px;
  left: 0px;
  transform: scale(0.7);
`;

export const MutedTypography = styled(Typography)<{
  enabledarktheme: boolean;
  fontWeight?: string;
}>`
  color: ${({ enabledarktheme }) => (enabledarktheme ? '#808080' : '#666')};
  font-size: 10px;
  font-weight: ${({ fontWeight }) => fontWeight};
`;

export const StyledTypography = styled(Typography)<{
  enabledarktheme: boolean;
  fontWeight?: string;
}>`
  color: ${({ enabledarktheme }) => (enabledarktheme ? '#fff' : '#000')};
  font-weight: ${({ fontWeight }) => fontWeight};
`;

export const BoldUnderlinedSpan = styled.span`
  font-weight: bold;
  text-decoration: underline;
`;

export const BoldSpan = styled.span`
  font-weight: bold;
`;

export const UnderlinedSpan = styled.span`
  text-decoration: underline;
`;

export const StyledAssetCardItemHeader = styled.div<{
  enabledarktheme: boolean;
}>`
  position: relative;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px 20px;
  background-color: ${({ enabledarktheme }) =>
    enabledarktheme ? darkPalette.modalBackground : '#fafafa'};
  padding: 10px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;

  &:hover {
    background-color: ${({ enabledarktheme }) =>
      enabledarktheme ? `${darkPalette.modalBackground}dd` : '#fafafadd'};
  }
`;
